/* @flow */
import * as React from 'react';

const Twitter = props => (
  <svg width={23} height={19} viewBox="0 0 23 19" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#4D93FF"
      fillRule="evenodd"
      d="M22.402,2.155 C21.578,2.521 20.691,2.768 19.762,2.878 C20.711,2.31 21.44,1.41 21.782,0.336 C20.894,0.862 19.911,1.246 18.864,1.451 C18.026,0.558 16.831,0 15.51,0 C12.972,0 10.915,2.058 10.915,4.596 C10.915,4.956 10.956,5.307 11.034,5.644 C7.214,5.451 3.827,3.622 1.561,0.842 C1.166,1.52 0.939,2.31 0.939,3.152 C0.939,4.746 1.7,6.153 2.934,6.977 C2.181,6.953 1.602,6.746 0.802,6.402 L0.802,6.459 C0.802,8.686 2.436,10.543 4.538,10.966 C4.152,11.072 3.771,11.128 3.352,11.128 C3.056,11.128 2.78,11.098 2.5,11.045 C3.085,12.87 4.788,14.199 6.799,14.237 C5.226,15.469 3.249,16.204 1.095,16.204 C0.723,16.204 0.359,16.182 0,16.139 C2.034,17.443 4.45,18.204 7.046,18.204 C15.498,18.204 20.121,11.202 20.121,5.128 C20.121,4.929 20.118,4.73 20.109,4.534 C21.007,3.886 21.785,3.078 22.402,2.155 Z"
    />
  </svg>
);

export default Twitter;



// WEBPACK FOOTER //
// ./src/assets/images/icons/twitter.js